import { useMutation } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const fetchCompanyListQuery = (id) => {
    return axios.get(`${apiurl?.getCompanyListByVessel}/?companyId=${id}`);
};

const fetchCompanyList = () => {
    return useMutation(['fetchCompanyList'], fetchCompanyListQuery);
};

export default fetchCompanyList;
